module.exports = __webpack_public_path__ + "static/media/19ESCAP17.1c3bb1ac.jpg";